import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { PMOrder } from 'src/app/models/domain';
import { YPMORDERSRVHeader } from 'src/generated-clients/order';

@Injectable({
  providedIn: 'root',
})
export class PMOrderAdapter implements IAdapter<PMOrder, YPMORDERSRVHeader> {
  public adaptToDomain(item: YPMORDERSRVHeader): PMOrder {
    return new PMOrder(
      fallbackString(item.orderNumber),
      fallbackString(item.equipmentNumber),
      fallbackString(item.shortDescription),
      fallbackString(item.orderType),
      fallbackString(item.orderTypeDescription),
      fallbackString(item.maintenancePlanningPlant),
      fallbackString(item.plannerGroup),
      fallbackString(item.plannerGroupName),
      fallbackString(item.priority),
      fallbackString(item.priorityDescription),
      fallbackString(item.maintenanceProcessingPhase),
      fallbackString(item.notificationNumber),
      fallbackString(item.objectNumber),
      fallbackString(item.systemStatus),
      fallbackString(item.longText),
      fallbackString(item.changeTime),
      fallbackString(item.changeBy),
      item.Slackdays ?? 0, // assuming Slackdays is numeric; fallback to 0 if null/undefined
      fallbackDate(item.basicFinishDate),
      fallbackDate(item.basicStartDate),
      fallbackDate(item.changeDate)
    );
  }
}
